/* rb-coa-carousel — arrows for the batch reports in the PDP "Product documentation" bubble.
 *
 * Every slide is already in the DOM (see snippets/rb-coa-carousel.liquid); this only moves the
 * `hidden` attribute between them. The position line and the report links are rendered by Liquid,
 * so nothing here writes text or URLs and the widget degrades to its first report without JS.
 *
 * Listening on the document rather than binding per widget is deliberate: main-product.liquid
 * renders one `.pfeatures` block per variant with `display:none`, revealed by the theme's own
 * variant-change script. A widget inside a block that is hidden at load still works the moment it
 * appears, with no re-initialisation and no dependency on that script's ordering.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('[data-rb-coa-step]');
    if (!button) return;

    var root = button.closest('[data-rb-coa-carousel]');
    if (!root) return;

    var slides = root.querySelectorAll('[data-rb-coa-slide]');
    if (slides.length < 2) return;

    var current = 0;
    for (var i = 0; i < slides.length; i++) {
      if (!slides[i].hidden) {
        current = i;
        break;
      }
    }

    var step = parseInt(button.getAttribute('data-rb-coa-step'), 10);
    if (!step) step = 1;

    /* Wraps, so the arrows never dead-end. Two reports is the common case and disabling an arrow
       at each end would leave one of them greyed out most of the time. */
    var next = (current + step + slides.length) % slides.length;
    if (next === current) return;

    slides[current].hidden = true;
    slides[next].hidden = false;
  });
})();
